import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import { Radio } from 'common-src/components/base';
import { getPrimaryPatientPhoneNumber } from 'common-src/models/PatientPhoneNumber/selectors';
import { singleModelSelector } from 'common-src/utils/selectorUtils';

import useCustomSelector from 'src/hooks/useCustomSelector';
import usePopup from 'src/hooks/usePopup';
import BasePopup from 'src/popups/BasePopup';

import styles from './SendScreenerLinkPopup.module.scss';

const CHANNEL = {
  EMAIL: 'email',
  SMS: 'sms',
};

const SendScreenerLinkPopup = ({
  patientId,
  caregiver,
  onClose,
  onSubmit,
  title = 'Send Screener Link',
}) => {
  const [channel, setChannel] = useState(null);

  const patient = useCustomSelector((state) => singleModelSelector(state, 'Patient', patientId));
  const primaryPatientPhoneNumber = useCustomSelector((state) =>
    getPrimaryPatientPhoneNumber(state, patientId),
  );

  const { renderButtons } = usePopup();

  const isForCaregiver = Boolean(caregiver);
  const hasEmail = isForCaregiver ? Boolean(caregiver?.email) : Boolean(patient?.email);
  const hasPhone = isForCaregiver ? Boolean(caregiver?.phone) : Boolean(primaryPatientPhoneNumber);

  const onSubmitHandler = (loadingCallback, successCallback, errorCallback) => {
    loadingCallback();
    onSubmit(
      channel,
      () => {
        successCallback();
        onClose();
      },
      errorCallback,
    );
  };

  return (
    <BasePopup id="send-screener-link" open onClose={onClose} title={title}>
      <div className={[styles.content, 'flex-column', 'gap-16'].join(' ')}>
        <p className="font-w-500">Choose how to send the link:</p>
        <Radio
          key={CHANNEL.EMAIL}
          id={CHANNEL.EMAIL}
          label="Email"
          disabled={!hasEmail}
          checked={_.isEqual(CHANNEL.EMAIL, channel)}
          onChange={() => setChannel(CHANNEL.EMAIL)}
        />
        <Radio
          key={CHANNEL.SMS}
          id={CHANNEL.SMS}
          label="SMS"
          disabled={!hasPhone}
          checked={_.isEqual(CHANNEL.SMS, channel)}
          onChange={() => setChannel(CHANNEL.SMS)}
        />
      </div>
      {renderButtons({
        containerClassName: styles.buttonsContainer,
        onClose,
        onSubmit: onSubmitHandler,
        submitButtonText: 'Send',
        isSubmitEnabled: Boolean(channel),
      })}
    </BasePopup>
  );
};

SendScreenerLinkPopup.propTypes = {
  patientId: PropTypes.number,
  caregiver: PropTypes.object,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
  title: PropTypes.string,
};

export default SendScreenerLinkPopup;
